import styled from '@emotion/styled';
import { CncReport } from '@gameonly/core';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useReport from '../cnc-reports/context/useReport';
import { HeaderContainer, HeaderSection } from '../layout/Header';

import { useTranslation } from 'react-i18next';
import { MiddleSection, RightSection } from '../layout/Header/Headers';
import { ReactComponent as Home } from '../ui/icons/home.svg';
import { ReactComponent as Next } from '../ui/icons/next.svg';

const BreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  svg {
    fill: white;
  }
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const Breadcrumb = ({ report }: { report?: CncReport }) => {
  const { t } = useTranslation(['cnc-reports', 'common', 'model']);
  const navigate = useNavigate();
  return (
    <BreadcrumbWrapper>
      <IconContainer onClick={() => navigate('/')}>
        <Home />
      </IconContainer>
      <IconContainer>
        <Next />
      </IconContainer>
      <Link to={`/cnc-reports`} className="h6r underline">
        {t('cnc-reports:title')}
      </Link>
      {!!report && (
        <>
          <IconContainer>
            <Next />
          </IconContainer>
          <Link to={`/cnc-reports/${report._id}`} className="h6r underline">
            {t('cnc-reports:report.title', { name: report.name })}
          </Link>
        </>
      )}
    </BreadcrumbWrapper>
  );
};
export const HeaderCncReports = () => {
  const { reportId } = useParams();
  const { report } = useReport(reportId);
  return (
    <HeaderContainer>
      <HeaderSection>
        <Breadcrumb report={report} />
      </HeaderSection>
      <HeaderSection marginBetween="16px" centered>
        <MiddleSection />
      </HeaderSection>
      <HeaderSection marginBetween="16px">
        <RightSection />
      </HeaderSection>
    </HeaderContainer>
  );
};
export default HeaderCncReports;
